















import {Component, Vue}         from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';
import {TabEnum}                from "@/util/enums/TabEnum";
import UIkit                    from "uikit";

@Component({
    computed  : {
        ...mapGetters({
            items            : 'infrastructureBatch',
            batchName        : 'infrastructureBatchName',
        }),
    },
    methods   : {
        ...mapActions({
            closeTab: 'closeTab',
        }),
    },
    components: {
        'Infrastructure': () => import("@/components/Infrastructure/Infrastructure.vue"),
        'Menu'          : () => import('@/components/ui/Menu.vue'),
    }
})
export default class BatchInfrastructure extends Vue {
    beforeMount() {
        if (this.$store.getters.selectedBatchUuid === "") {
            UIkit.notification('Необходимо выбрать участок!');
            this.$store.dispatch("changeTab", TabEnum.SearchBar);
        }
    }
}
